// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1io8p","balanceDisclaimer":"posDashboard_balanceDisclaimer__2DhJr"};